import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton } from 'material-ui/RadioButton';
import ChargeRow from 'chargeComponents/ChargeRow';
import { textUtils } from '../../utils/textUtils';

const RadioGroupOptionsTable = (props) => {

    const { options, selectedOptions, onRadioGroupButtonChange, includeBlankOption, blankOptionLabel } = props;
    if (!options || options.length === 0) {
        return null;
    }

    const rows = [];
    const selectedValues = selectedOptions ? selectedOptions : [];

    if (options && options.length > 0) {
        options.forEach((item) => {
            const radioButton = <RadioButton
                disabled={false}
                key={'rb_radiooption_' + item.value}
                value={item.value}
                onClick={() => onRadioGroupButtonChange(item.value)}
                checked={selectedValues.some(selected => selected.value === item.value)}
            />;

            rows.push(
                <ChargeRow
                    key={'rb_rowoption_' + item.value}
                    hasUnsavedChanges={false}
                    title={item.description}
                    inputFirst={false}
                    label={item.label}
                    option={radioButton}
                    loading={false}
                />
            );
        });

        if (includeBlankOption) {
            rows.push(
                <ChargeRow
                    key={'row-none-option'}
                    hasUnsavedChanges={false}
                    title={'None'}
                    inputFirst={false}
                    label={blankOptionLabel}
                    option={<RadioButton
                        disabled={false}
                        key={'rb-none-option'}
                        value={textUtils.security.noOptionSelected}
                        checked={selectedValues ? selectedValues.length === 0 : true}
                        onClick={(e) => onRadioGroupButtonChange(e.target.value)}
                    />}
                />
            );
        }
    }
    return (
        <table className="table bordered condensed">
            <tbody>
                {rows}
            </tbody>
        </table>
    );
}


RadioGroupOptionsTable.propTypes = {
    options: PropTypes.array,
    onRadioGroupButtonChange: PropTypes.func,
    selectedOptions: PropTypes.array,
    includeBlankOption: PropTypes.bool,
    blankOptionLabel: PropTypes.any
};

export default RadioGroupOptionsTable;


// WEBPACK FOOTER //
// ./src/components/equipment/RadioGroupOptionsTable.js